$(document).ready(function () {
   // Enable checkboxes after page load
   $("input[type='checkbox']").prop("disabled", false);

   // Scroll to top on page unload
   $(window).on("beforeunload", function () {
      $(window).scrollTop(0);
   });

   // Show/Hide header tabs
   $(".tab").click(function () {
      let tabId = $(this).attr("data-id");

      $(".tab-content").removeClass("active-tab-content");
      $(`.tab-content[data-id='${tabId}']`).addClass("active-tab-content");

      $(".tab").removeClass("active-tab");
      $(this).addClass("active-tab");

      $("#searchbar").val("").trigger("keyup");
      $("html, body").animate({ scrollTop: 0 }, 500, "swing");
   });

   // Sticky header on scroll
   $(window).scroll(function () {
      let height = $(window).height();
      let scroll = $(window).scrollTop();
      $(".sticky-header").toggleClass("show", scroll > height);
   });

   function imageUpdate(tabId) {
      let $imageList = $(`#tab_images li img`);
      $imageList.attr("src", "");
      let index = 0;

      $("#flexi-box-form")
      .find(".product-checkbox:checked")
      .each(function () {
         let imgUrl = $(this).data("img");
         let qty = parseInt($(this).closest(".product-info").find(".quantity-input").val() || 1);

         // Repeat image based on quantity
         for (let i = 0; i < qty; i++) {
            if (index < $imageList.length) {
               $imageList.eq(index).attr("src", imgUrl);
               index++;
            }
         }
      });
   }

   // Build product list
   function listAdd() {
      let totalPrice = 0;
      let update_price = 0;
      
      $("#bundle_submit input[name^='properties[sub_item_']").remove();
      $("#bundle_submit input[name='properties[uniware_items]']").remove();

      $("#flexi-box-form")
         .find(".product-checkbox:checked")
         .each(function () {
            let quantity =
               parseInt($(this).closest(".product-info").find(".quantity-input").val()) || 1;
            let bundleParts = $(this).attr("data-bundle").split("/");
            totalPrice += parseFloat(bundleParts[1]) * quantity;
         });

      let items = 0;
      let productData = { properties: { uniware_items: { items: [] } } };

      let $parentbox = $("#parentSKU");

      let itemObjParent = {
         id: $parentbox.data("store-id") || "",
         quantity: 1,
         varint_title: $parentbox.data("variant-title") || "",
         origin_location: "",
         fulfillment_status: "",
         total_discount: "",
         gift_card: "",
         requires_shipping: "",
         total_discount_set: "",
         title: $parentbox.data("product-name"),
         variant_id: $parentbox.data("variant-id") || "",
         tax_lines: "",
         mrp: "",
         price: 0,
         grams: "",
         sku: $parentbox.data("sku") || "",
         vendor: $parentbox.data("vendor") || "",
         product_id: $parentbox.data("product-id") || "",
         currency_code: "INR",
         fulfillable_quantity: "",
         fulfillment_service: "",
         taxable: "",
         discount_allocations: "",
         name: $parentbox.data("product-name") || "",
         price_set: "",
         properties: '{"_product":"parent"}',
         duties: ""
      };
      productData.properties.uniware_items.items.push(itemObjParent);

      $("#flexi-box-form")
         .find(".product-checkbox:checked")
         .each(function () {
            let $checkbox = $(this);
            let productValue = $checkbox.val();
            let productName = $checkbox.attr("name") || "";

            if (
               !productValue ||
               productValue.toLowerCase() === "no" ||
               productValue.toLowerCase().includes("hidden") ||
               productName.toLowerCase().includes("hidden")
            ) {
               $checkbox.prop("disabled", true);
               return;
            }

            let bundle = $checkbox.attr("data-bundle") || "";
            let quantity =
               parseInt($checkbox.closest(".product-info").find(".quantity-input").val()) || 1;

            let originalValue =
               $checkbox.attr("data-original-value") ||
               productValue.split(" (Qty:")[0];
            $checkbox.attr("data-original-value", originalValue);

            let productProperty = originalValue;
            if (quantity > 1) productProperty += ` (Qty: ${quantity})`;

            $checkbox.attr("name", "properties[Item " + items + "]");
            $checkbox.val(productProperty);

            let bundleParts = bundle.split("/");
            update_price =
               (parseFloat(bundleParts[1]) * quantity / totalPrice) *
               $checkbox.data("bundle-price");
            let sub_sku = $checkbox.data("sku") || "";
            let sub_img = $checkbox.data("img_name") || "";
            
            let itemObj = {
               id: $checkbox.data("store-id") || "",
               quantity: quantity,
               varint_title: $checkbox.data("variant-title") || "",
               origin_location: "",
               fulfillment_status: "",
               total_discount: "",
               gift_card: "",
               requires_shipping: "",
               total_discount_set: "",
               title: originalValue,
               variant_id: $checkbox.data("variant-id") || "",
               tax_lines: "",
               mrp: "",
               price: update_price.toFixed(2) || $checkbox.data("price") || "",
               grams: "",
               sku: sub_sku,
               vendor: $checkbox.data("vendor") || "",
               product_id: $checkbox.data("product-id") || "",
               currency_code: "INR",
               fulfillable_quantity: "",
               fulfillment_service: "",
               taxable: "",
               discount_allocations: "",
               name: $checkbox.data("product-name") || "",
               price_set: "",
               properties: '{"_product":"child"}',
               duties: ""
            };
            let item_index = items + 1;
            let subItemLabel = `sub_item_${item_index}`;
            let subItemValue = `${originalValue} x ${quantity} :: ${sub_img}`;
            $("<input>")
               .attr("type", "hidden")
               .attr("name", `properties[${subItemLabel}]`)
               .val(subItemValue)
               .appendTo("#bundle_submit");
            productData.properties.uniware_items.items.push(itemObj);
            items++;
         });

      // Convert to JSON string
      productData.properties.uniware_items = JSON.stringify(
         productData.properties.uniware_items
      );

      // Add main uniware JSON
      $("<input>")
         .attr("type", "hidden")
         .attr("name", "properties[uniware_items]")
         .val(productData.properties.uniware_items)
         .appendTo("#bundle_submit");
   }

   let checkboxes = $("input[type='checkbox']");

   // Quantity helpers
   function updateQuantity(input, change) {
      let currentVal = parseInt(input.val()) || 1;
      let newVal = currentVal + change;
      let maxVal = parseInt(input.attr("max")) || 999;
      let minVal = parseInt(input.attr("min")) || 1;

      if (newVal >= minVal && newVal <= maxVal) {
         input.val(newVal);
         input.closest(".product-info").find(".product_counter").text(newVal);
      }
   }

   function getTotalSelectedQuantityInTab(tabId) {
      let total = 0;
      $(`[data-id="tab${tabId}"] .product-checkbox:checked`).each(function () {
         let quantity =
            parseInt($(this).closest(".product-info").find(".quantity-input").val()) || 1;
         total += quantity;
      });
      return total;
   }

   function updateTabCounts(tabId) {
      let totalSelected = getTotalSelectedQuantityInTab(tabId);
      let $tabContent = $(`.tab-content[data-id="tab${tabId}"]`);
      let selectionLimit = parseInt($tabContent.attr("data-product-limit"));
      let currProductDataId = "tab_" + tabId + "_product";

      imageUpdate(tabId);

      if (totalSelected === selectionLimit) {
         $(`#checkbox_count_${currProductDataId}`)
            .css("display", "inline-block")
            .html(`&#10004;`);
         $tabContent.find(".product-checkbox:not(:checked)").prop("disabled", true);
         $tabContent.find(".product-checkbox:not(:checked)").each(function () {
            $(this).closest(".add-to-box").addClass("disables");
         });
      } else if (totalSelected > 0) {
         $(`#checkbox_count_${currProductDataId}`)
            .css("display", "inline-block")
            .text(totalSelected);
         $tabContent.find(".product-checkbox:not(:checked)").prop("disabled", false);
         $tabContent.find(".add-to-box").removeClass("disables");
      } else {
         $(`#checkbox_count_${currProductDataId}`).css("display", "none");
         $tabContent.find(".product-checkbox:not(:checked)").prop("disabled", false);
         $tabContent.find(".add-to-box").removeClass("disables");
      }

      checkSubmitButtonVisibility();

      if (totalSelected === selectionLimit) {
         let nextTab = `tab${parseInt(tabId) + 1}`;
         if ($(`.tab[data-id='${nextTab}']`).length > 0) {
            setTimeout(() => {
               $(`.tab[data-id='${nextTab}']`).click();
               $("#searchbar").val("").trigger("keyup");
               $("html, body").animate({ scrollTop: 0 }, 500, "swing");
            }, 500);
         }
      }
   }

   function checkSubmitButtonVisibility() {
      let totalSelectedAcrossAllTabs = 0;
      $(".tab-content").each(function () {
         let tabId = $(this).attr("data-id").replace("tab", "");
         totalSelectedAcrossAllTabs += getTotalSelectedQuantityInTab(tabId);
      });

      if (totalSelectedAcrossAllTabs == totalproductSelection) {
         $("#submit-btn").css("display", "inline-block");
         $("#gokwik-buy-now").prop("disabled", false)
         listAdd();
      } else {
         $("#submit-btn").css("display", "none");
         $("#gokwik-buy-now").prop("disabled", true);
      }
   }

   // Quantity +/- controls
   $(document).on("click", ".quantity-plus", function (e) {
      e.preventDefault();
      let input = $(this).siblings(".quantity-input");
      let currTabId = parseInt(input.attr("data-tab-index"));
      let selectionLimit = parseInt(
         $(`.tab-content[data-id="tab${currTabId}"]`).attr("data-product-limit")
      );

      let totalSelectedInTab = getTotalSelectedQuantityInTab(currTabId);
      let currentQuantity = parseInt(input.val()) || 1;

      if (totalSelectedInTab - currentQuantity + (currentQuantity + 1) <= selectionLimit) {
         updateQuantity(input, 1);
         updateTabCounts(currTabId);
      }
   });

   $(document).on("click", ".quantity-minus", function (e) {
      e.preventDefault();
      let input = $(this).siblings(".quantity-input");
      let currTabId = parseInt(input.attr("data-tab-index"));
      updateQuantity(input, -1);
      updateTabCounts(currTabId);
   });

   $(document).on("change", ".quantity-input", function () {
      let currTabId = parseInt($(this).attr("data-tab-index"));
      let selectionLimit = parseInt(
         $(`.tab-content[data-id="tab${currTabId}"]`).attr("data-product-limit")
      );
      let totalSelectedInTab = getTotalSelectedQuantityInTab(currTabId);

      if (totalSelectedInTab > selectionLimit) $(this).val(1);
      updateTabCounts(currTabId);
   });

   // Checkbox click handler
   checkboxes.click(function () {
      let currProductDataId = $(this).attr("data-id-products");
      let currTabId = Number(currProductDataId.split("_")[1]);
      let selectionLimit = parseInt(
         $(`.tab-content[data-id="tab${currTabId}"]`).attr("data-product-limit")
      );

      if ($(this).is(":checked")) {
         let currentTabTotal = getTotalSelectedQuantityInTab(currTabId);
         if (currentTabTotal > selectionLimit) {
            $(this).prop("checked", false);
            return;
         }

         $(this).parents(".product-info").find(".quantity-selector").show();
         $(this).parents(".product-info").find(".added_to_cart").removeClass("_hidden");
         $(this).parents(".product-info").find(".product_counter").removeClass("_hidden");
         $(this).closest(".product-info").find(".quantity-input").val(1);
         $(this).parents(".product-info").find(".product_counter").text("1");

         let productTitle = $(this).val().split(" SKU:")[0];
         $(".Message_Bar").removeClass("is-hidden");
         $(".Message_Bar p span").text(productTitle);
         setTimeout(function () {
            $(".Message_Bar").addClass("is-hidden");
            $(".Message_Bar p span").text("");
         }, 2500);
      } else {
         $(this).parents(".product-info").find(".added_to_cart").addClass("_hidden");
         $(this).parents(".product-info").find(".product_counter").addClass("_hidden");
         $(this).parents(".product-info").find(".quantity-selector").hide();
         $(this).closest(".product-info").find(".quantity-input").val(1);
         $(this).parents(".product-info").find(".product_counter").text("1");
      }
      updateTabCounts(currTabId);
   });

   // Disable right-click + F12
   $(document).bind("contextmenu", function (e) { e.preventDefault(); });
   $(document).keydown(function (e) { if (e.which === 123) return false; });

   // Search
   $("#searchbar").on("keyup", function () {
      var value = $(this).val().toLowerCase();
      $("#collection-list li").filter(function () {
         $(this).toggle($(this).find("a").text().toLowerCase().indexOf(value) > -1);
      });
   });

   $(".search-clear").click(function () {
      $("#searchbar").val("").trigger("keyup");
   });

   // ---------------------------
    // Buy Now Button Integration
    // ---------------------------
    $(document).on("click", "#gokwik-buy-now", function (e) {
       e.preventDefault();

       let productItems = [];
       
       let variant = $("#bundle_submit input[name='id']").val() || "";
       let props = {
          custom_flag: "flexibox",
          byob: true
       };

       // Include sub_item_1, sub_item_2, etc.
       $("#bundle_submit input[name^='properties[sub_item_']").each(function () {
          let name = $(this).attr("name").replace("properties[", "").replace("]", "");
          props[name] = $(this).val();
       });
       props["uniware_items"] = $("#bundle_submit input[name='properties[uniware_items]']").val() || "";

       productItems.push({
          id: variant,
          quantity: 1,
          properties: props
       });

       console.log("Bundle Variant:", variant);
       console.log("Props Sent:", props);

       if (productItems.length) {
          onBuyNowClick(e, false, productItems);
       }
    });
});
